var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 550 450",
    style: {
      enableBackground: "new 0 0 550 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.9,2.6c-5.6-2.7-12.1-2-16.9,1.9L170.4,129H96c-17.6,0-32,14.4-32,32v128c0,17.7,14.4,32,32,32h74.4 L326,445.6c2.9,2.3,6.5,3.5,10,3.5c2.4,0,4.7-0.5,6.9-1.6c5.5-2.7,9.1-8.3,9.1-14.4V17C352,10.9,348.5,5.3,342.9,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M433,111.9c-6.3-6.2-16.4-6.1-22.6,0.1c-6.2,6.3-6.1,16.4,0.1,22.7c24.2,23.9,37.5,56,37.5,90.4 s-13.3,66.5-37.5,90.4c-6.3,6.2-6.3,16.3-0.1,22.6c3.1,3.2,7.3,4.7,11.4,4.7c4.1,0,8.1-1.5,11.3-4.6c30.3-29.9,47-70,47-113.1 S463.3,141.8,433,111.9L433,111.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M478.1,66.8c-6.3-6.2-16.4-6.2-22.7,0.1c-6.2,6.3-6.1,16.4,0.1,22.6C492,125.6,512,173.7,512,225 s-20,99.4-56.4,135.5c-6.2,6.2-6.3,16.4-0.1,22.7c3.2,3.1,7.3,4.7,11.4,4.7c4.1,0,8.2-1.5,11.3-4.6C520.6,341.2,544,285,544,225 S520.6,108.9,478.1,66.8L478.1,66.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.9053967cbcdc2ccc8cd1fd44eec4399e.svg";
export { ForwardRef as ReactComponent };